import { action } from 'typesafe-actions';
import { AnonymTypes } from './types';

export const anonymRequest = () => action(AnonymTypes.ANONYM_RESQUEST, {});

export const anonymSuccess = (data: any) =>
  action(AnonymTypes.ANONYM_SUCCESS, { data });

export const anonymFailure = () => action(AnonymTypes.ANONYM_FAILURE, {});

export const postAnonymRequest = (recaptcha: string) =>
  action(AnonymTypes.POST_ANONYM_RESQUEST, { recaptcha });

export const postAnonymSuccess = (data: any) =>
  action(AnonymTypes.POST_ANONYM_SUCCESS, { data });

export const postAnonymFailure = () =>
  action(AnonymTypes.POST_ANONYM_FAILURE, {});

export const deleteAnonymRequest = (recaptcha: string) =>
  action(AnonymTypes.DELETE_ANONYM_RESQUEST, { recaptcha });

export const deleteAnonymSuccess = (data: any) =>
  action(AnonymTypes.DELETE_ANONYM_SUCCESS, { data });

export const deleteAnonymFailure = () =>
  action(AnonymTypes.DELETE_ANONYM_FAILURE, {});
